import { Activity, Company, EntityType, Person } from "@mapmycustomers/shared/types/entity";

import { RawTimelineEvent } from "@app/types/events/TimelineEvent";

export interface CheckInEntityRef {
  activity: Activity;
  entityId: Company["id"] | Person["id"];
  entityType: EntityType.COMPANY | EntityType.PERSON;
}

// A check-in is a crm-activity timeline event whose checkInType points at the visited company/person.
// Classify by checkInType, NEVER by audit action: the same check-in can arrive as "record added",
// "activity completed", or "activity assigned" (mmc-server overwrites "record added" once the check-in
// is completed/assigned), or "record updated,activity completed" when a check-in is added to an existing
// activity (e.g. checking in on a scheduled visit). crm-activity-service.calculateCheckInData sets
// checkInType on both the create and update paths. Returns the activity plus its (type, id) reference,
// or undefined for non-check-in events. Shared by buildCheckIn (resolves the pin) and the fetchCheckInPins
// saga (fetches it) so the rule lives once.
const getCheckInEntityRef = (event: RawTimelineEvent): CheckInEntityRef | undefined => {
  const entity = event.entity;
  if (!entity || entity.entity !== EntityType.ACTIVITY) {
    return undefined;
  }
  switch (entity.checkInType) {
    case EntityType.COMPANY:
      return entity.account
        ? { activity: entity, entityId: entity.account.id, entityType: EntityType.COMPANY }
        : undefined;
    case EntityType.PERSON:
      return entity.contact
        ? { activity: entity, entityId: entity.contact.id, entityType: EntityType.PERSON }
        : undefined;
    default:
      return undefined;
  }
};

export default getCheckInEntityRef;
